export default __webpack_public_path__ + "static/media/linkedin.03f1d164.svg";